import { createStructureStatementHandler } from '../../createStructureStatementHandler';
import { getFormName, getScopeName, getViewName } from '../../utils/nameFormat';
const productScope = getScopeName({ entityName: 'Product' });
const productForm = getFormName('Product');
export const createFormStmtInstruction = `
#### Create form
Use this command to create a form for a specific entity.

- Syntax: \`create form <form_name> for Product;\`
- Example: \`create form ${productForm} for Product;\`


#### Add form to scope
Use this command to add a form to a specific scope. This command is designed to enhance the representation of user interfaces that require repetitive and variable user input structures.

- Syntax: \`add form <form_name> in <view_name>.<scope_name> for <entity_name>;\`
- Example: \`add form ${productForm} in ${getViewName({ entityName: 'Product', viewType: 'create' })}.${productScope} for Product;\`
- Example: \`add form ${productForm} in ${getViewName({ entityName: 'Product', viewType: 'edit' })}.${productScope} for Product;\`
`;
export const stmtCreateForm = ({ formName, viewName, scopeName, entityName }) => {
    if (!viewName || !scopeName) {
        return `create form ${formName} for ${entityName};`;
    }
    return `add form ${formName} in ${viewName}.${scopeName} for ${entityName};`;
};
export const createFormHandler = createStructureStatementHandler({
    type: 'add form',
    parse: line => {
        const match = /^(add|create) form (?<formName>\w+)( in (?<viewName>\w+).(?<scopeName>\w+))? for (?<entityName>\w+)/.exec(line);
        return match?.groups
            ? {
                type: 'add form',
                formName: match.groups.formName,
                viewName: match.groups.viewName,
                scopeName: match.groups.scopeName,
                entityName: match.groups.entityName,
            }
            : null;
    },
    apply: (stmt, builder) => {
        builder.updateStructure(it => {
            return it.addForm({
                formName: stmt.formName,
                scopeName: stmt.scopeName,
                viewName: stmt.viewName,
                entityName: stmt.entityName,
            });
        });
    },
});
//# sourceMappingURL=CreateFormStmt.js.map